import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

  :root {
    --color-alert-400: rgb(207, 0, 0);
    --color-alert-600: rgb(160, 27, 27);
    --color-alert-100: rgb(255, 216, 216);

    --color-success-400: rgb(0, 191, 190);

    --color-auth-bg: rgb(23, 25, 24);
    --color-auth-float-link: rgba(255, 255, 255, 0.8);
    --color-auth-box-bg: rgb(42, 44, 43);
    --color-auth-label: rgb(255, 255, 255);
    --color-auth-input-bg: rgb(66, 69, 67);
    --border-radius: 4px;

    --color-dark-400: rgb(15, 15, 15);
    --color-dark-350: rgb(23, 25, 24);
    --color-dark-350-70: rgba(23, 25, 24, 0.70);
    --color-dark-150: rgb(42, 44, 43);

    --color-gray-200: rgb(227, 227, 227);
    --color-gray-400: rgb(179, 181, 180);
    
    
    --color-footer: var(--color-auth-float-link);
  }

  .btn-auth-external {
    text-decoration: underline;
  }

  .theme-b3 {
    --color-alert-400: #CC4400;
    --color-alert-600: #b32b00;
    --color-alert-100: #e55d19;

    --color-success-400: #28a745;

    --color-auth-bg: rgb(255, 255, 255);
    --color-auth-float-link: #666E7A;
    --color-auth-box-bg: #F0F5FD;
    --color-auth-label: #40444D;
    --color-auth-input-bg: #E3E5E7;
    --border-radius: 40px;

    --color-dark-400: #002C63;
    --color-dark-350: rgb(1, 22, 98);
    --color-dark-350-70: rgba(1, 22, 98, 0.70);
    --color-dark-150: #0063DE;

    --color-gray-200: #F8F8F8;
    --color-gray-400: rgb(30, 32, 35);

    --color-footer: white;

    .btn-auth-external {
      color: rgb(0, 99, 222);
      text-transform: uppercase;
      text-decoration: none;
      font-size: 0.75rem;
      font-weight: 700;
    }
  }

  .theme-nasescolas {
    --color-auth-bg: rgb(255, 255, 255);
    --color-auth-float-link: #666E7A;
    --color-auth-box-bg: #F0F5FD;
    --color-auth-label: #40444D;
    --color-auth-input-bg: #E3E5E7;
  }

  .theme-genoveva {
    --color-auth-bg: rgb(255, 255, 255);
    --color-auth-float-link: #666E7A;
    --color-auth-box-bg: #F0F5FD;
    --color-auth-label: #40444D;
    --color-auth-input-bg: #E3E5E7;
  }

  .theme-floripaedu {
    --color-auth-bg: rgb(255, 255, 255);
    --color-auth-float-link: #666E7A;
    --color-auth-box-bg: #F0F5FD;
    --color-auth-label: #40444D;
    --color-auth-input-bg: #E3E5E7;
  }

  .theme-biguacuedu {
    --color-auth-bg: rgb(255, 255, 255);
    --color-auth-float-link: #666E7A;
    --color-auth-box-bg: #F0F5FD;
    --color-auth-label: #40444D;
    --color-auth-input-bg: #E3E5E7;
  }

  .theme-curitibaedu {
    --color-auth-bg: rgb(255, 255, 255);
    --color-auth-float-link: #666E7A;
    --color-auth-box-bg: #F0F5FD;
    --color-auth-label: #40444D;
    --color-auth-input-bg: #E3E5E7;
  }



  .theme-wrapper.theme-wrapper-mobile {
    max-width: 100vw;
    overflow-x: hidden;
  }

  html,
  body,
  #root {
    max-width: 100vw;
    height: 100vh;
  }

  /* Box sizing rules */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  * {
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.gray_600} ${({ theme }) => theme.colors.gray_300};

  /* Works on Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.gray_300};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.gray_600};
    border: 2px solid ${({ theme }) => theme.colors.gray_300};
    border-radius: 10px;
  }
}



  /* Remove default padding, Remove list styles on ul, ol elements with a class attribute */
  ul[class],
  ol[class] {
    padding: 0;
    list-style: none;
  }

  /* Remove bold heading */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: normal;
  }

  /* Remove default margin */
  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul[class],
  ol[class],
  li,
  figure,
  figcaption,
  blockquote,
  dl,
  dd {
    margin: 0;
  }

  a {
    text-decoration: none;
    cursor: pointer;
  }

  html {
    line-height: 1.15;
    text-size-adjust: 100%;
  }

  /* Set core body defaults */
  body {
    padding: 0;
    min-height: 100vh;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;
    line-height: 1.5;
    font-family: Roboto, sans-serif;
    font-size: 16px;
    background-color: ${({ theme: { colors } }) => colors.gray_200};
    color: ${({ theme: { colors } }) => colors.dark_350};
    overflow-y: auto;
    overflow-x: hidden;

    > iframe {
      display: none;
    }
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  /* Make images easier to work with */
  img {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
    user-select: none;
  }

  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  ul.list {
    list-style: none;

    li {
      padding-left: 15px;
      position: relative;
      padding-bottom: 5px;

      &:last-child {
        padding-bottom: 0;
      }

      &::before {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        background: ${({ theme: { colors } }) => colors.primary_400};
        position: absolute;
        top: 8px;
        left: 0px;
      }
    }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  textarea:-webkit-autofill:active,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus,
  select:-webkit-autofill:active {
    -webkit-text-fill-color: ${({ theme }) => theme.colors.primary_400};
    -webkit-box-shadow: 0 0 0px 1000px #2A2C2B inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  .contentHat {
    ${({ theme: { mediaQueries, fontSizes } }) => {
      return `
        font-size: ${fontSizes[2]};

        ${mediaQueries.desktop} {
          font-size: ${fontSizes[5]};
        }
      `;
    }}
  }

  .contentName {
    line-height: 1.3;

    ${({ theme: { mediaQueries, fontSizes, fontWeights } }) => {
      return `
        font-size: ${fontSizes[5]};
        font-weight: ${fontWeights.bold};
        margin-top: 5px;
        margin-bottom: 15px;

        ${mediaQueries.tablet} {
          font-size: ${fontSizes[6]};
        }

        ${mediaQueries.desktop} {
          font-size: ${fontSizes[8]};
          margin-bottom: 25px;
        }
      `;
    }}
  }

  .contentTitle {
    font-weight: ${({ theme }) => theme.fontWeights.bold};

    ${({ theme: { mediaQueries, fontSizes } }) => {
      return `
        font-size: ${fontSizes[3]};
        margin-bottom: 5px;

        ${mediaQueries.desktop} {
          font-size: ${fontSizes[5]};
          margin-bottom: 10px;
        }
      `;
    }}
  }

  .contentSubTitle {
    font-weight: ${({ theme }) => theme.fontWeights.bold};

    ${({ theme: { mediaQueries, fontSizes } }) => {
      return `
        font-size: ${fontSizes[2]};

        ${mediaQueries.desktop} {
          font-size: ${fontSizes[3]};
        }
      `;
    }}
  }

  .sideBySide {
    ${({ theme: { mediaQueries } }) => {
      return `
        display: block;

        .sideLeft {
          width: 100%;
        }

        .sideRight {
          width: 100%;
          margin-top: 30px;
        }

        ${mediaQueries.desktop} {
          display: flex;
          flex-wrap: nowrap;

          .sideLeft,
          .sideRight {
            width: 50%;

            &.w45 { width: 45%}
            &.w55 { width: 55%}
          }

          .sideLeft {
            padding-right: 30px;
          }

          .sideRight {
            margin-top: inherit;
            padding-left: 30px;
          }
        }
      `;
    }}
  }
`;

export default GlobalStyle;
